<div class="table-dropdown-api-container" [style.marginTop]="data?.marginTop">
  <h3 class="table-title" *ngIf="data?.title">{{ data?.title }}</h3>

  <div class="table-actions" *ngIf="showAddRowButton">
    <button type="button" class="add-row-button" (click)="onAddRowClick($event)">
      {{ addRowButtonLabel }}
    </button>
  </div>

  <div
    class="table-shell"
    [style.maxHeight.px]="tableViewportMaxHeightPx"
    [style.height.px]="tableViewportHeightPx"
    [style.overflowY]="tableViewportOverflowY">
    <table mat-table [dataSource]="dataSource" class="dropdown-api-table">
      <ng-container *ngFor="let column of tableColumns" [matColumnDef]="column" [sticky]="isFrozenColumn(column)">
        <th mat-header-cell *matHeaderCellDef class="header-cell" [ngClass]="getHeaderCellClasses(column)"
          [attr.data-column-key]="column" [ngStyle]="getColumnStyle(column)">
          <div class="header-content">
            <span class="header-text">{{ formatHeaderLabel(columnLabels[column]) }}</span>
            <button
              *ngIf="canToggleColumnEdit(column)"
              type="button"
              class="header-edit-toggle"
              [class.active]="isColumnEditEnabled(column)"
              (click)="toggleColumnEdit(column, $event)"
              [attr.aria-label]="isColumnEditEnabled(column) ? 'Disable edit mode' : 'Enable edit mode'">
              <mat-icon>{{ isColumnEditEnabled(column) ? 'check' : 'edit' }}</mat-icon>
            </button>
          </div>
        </th>

        <td mat-cell *matCellDef="let row; let rowIndex = index" class="body-cell"
          [ngClass]="getBodyCellClasses(column, row, rowIndex)" [attr.data-column-key]="column"
          [ngStyle]="getColumnStyle(column, row)" [class.cell-selected]="isCellSelected(rowIndex, column)"
          [class.cell-selection-enabled]="isCellSelectionEnabled"
          (click)="onCellSelectionToggle(rowIndex, column, $event)">

          <ng-container *ngIf="isDropdownColumn(column, row) && isColumnEditable(column, row); else nonDropdownCell">
            <mat-form-field appearance="outline" class="dropdown-field" (click)="$event.stopPropagation()">
              <mat-select [multiple]="isMultiSelect(column, row)" [ngModel]="row[column]"
                (ngModelChange)="onDropdownChange(row, column, $event)"
                (openedChange)="onDropdownOpened($event, row, column, rowIndex)"
                [placeholder]="getDropdownPlaceholder(column, row)"
                [disabled]="isDropdownLoading(row, column, rowIndex)">
                <mat-option *ngIf="isDropdownLoading(row, column, rowIndex)" [disabled]="true">
                  Loading options...
                </mat-option>
                <mat-option *ngFor="let option of getDropdownOptions(row, column, rowIndex)" [value]="option.value">
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>

          <ng-template #nonDropdownCell>
            <ng-container *ngIf="isInputColumn(column, row) && isColumnEditable(column, row); else textCell">
              <mat-form-field appearance="outline" class="input-field" (click)="$event.stopPropagation()">
                <input matInput [type]="getInputType(column, row)"
                  [attr.inputmode]="isNumericColumn(column, row) ? 'decimal' : null"
                  [ngModel]="getInputDisplayValue(column, row[column], row)"
                  (ngModelChange)="onTextInputChange(row, column, $event)"
                  [placeholder]="getInputPlaceholder(column, row)" />
              </mat-form-field>
            </ng-container>
            <ng-template #textCell>
              {{ getCellDisplayValue(column, row[column], row) }}
            </ng-template>
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns; let rowIndex = index"
        [class.row-selection-enabled]="isRowSelectionEnabled" [class.row-selected]="isRowSelected(rowIndex)"
        [class.conflict-row]="isConflictRow(row)"
        (click)="onRowSelectionToggle(rowIndex)"></tr>
    </table>
  </div>

  <div class="loading-note" *ngIf="isOnInitDataLoading">
    Loading table data...
  </div>

  <div class="table-footer-line" *ngIf="shouldShowFooterLine">
    <h4 class="table-footer-text">{{ footerLineText }}</h4>
  </div>

  <div class="table-footer-actions" *ngIf="showFooterButton">
    <button
      *ngFor="let config of footerButtonConfigs"
      type="button"
      class="footer-action-button"
      [ngClass]="getFooterButtonClasses(config)"
      [style.marginLeft]="config.marginLeft"
      [disabled]="isFooterButtonDisabled(config) || loadingButtons.has(getFooterButtonLabel(config))"
      (click)="onFooterButtonClick(config, $event)">
      {{ getFooterButtonRenderLabel(config) }}
    </button>
  </div>
</div>
